<template lang="pug">
#good_service
  custom-header(
    :title="goodService.area01_Title",
    :subTitle="goodService.area01_SubTitle",
    :image="goodService.area01_Image",
    :buttonName="goodService.area01_ButtonName",
    :buttonURL="goodService.area01_ButtonURL"
  )
  section.container-fluid.bg_light_blue.i_pt_12.i_pt_md_6.i_pt_sm_8.i_pb_16
    .container
      .row
        .col-12.i_mt_6(
          v-for="(service, index) in currentDifferentServieceList"
        )
          service-card(@openDialog="openDialog", :item="service")
  dialog-html(
    v-if="dialogShow",
    @closeDialog="closeDialog",
    :detail="cardDetail"
  )
</template>

<script>
import CustomHeader from "@/components/customer_service/Header";
import ServiceCard from "@/components/customer_service/ServiceCard";
import DialogHtml from "@/components/common/dialog/DialogHtml";
import { getGoodService } from "@/json/customer_service";
import { getDifferentServiceList } from "@/json/different";
import { stopScroll, startScroll } from "@/utils/scroll";

export default {
  name: "CustomerServiceGoodService",
  metaInfo() {
    return {
      title: this.goodService.SEO_Title,
      meta: [
        { name: "description", content: this.goodService.SEO_Description },
      ],
    };
  },
  components: { ServiceCard, CustomHeader, DialogHtml },
  data() {
    return {
      dialogShow: false,
      cardDetail: {},
      goodService: {},
      currentDifferentServieceList: [],
      differentServiceList: [],
    };
  },
  created() {
    this.getGoodService();
  },
  methods: {
    openDialog(object) {
      this.cardDetail = object;
      this.dialogShow = true;
      stopScroll();
    },
    closeDialog() {
      this.dialogShow = false;
      startScroll();
    },
    getGoodService() {
      getGoodService().then((response) => {
        this.goodService = response.data;
        getDifferentServiceList().then((response) => {
          this.differentServiceList = response.data.DifferentServiceList;
          this.getCurrentDifferentServiceList();
        });
      });
    },
    getCurrentDifferentServiceList() {
      if (
        this.goodService.area02_DifferentServiceList &&
        this.goodService.area02_DifferentServiceList.length > 0
      ) {
        for (let x in this.goodService.area02_DifferentServiceList) {
          let id = this.goodService.area02_DifferentServiceList[x];
          for (let y in this.differentServiceList) {
            let temp = this.differentServiceList[y];
            if (id == temp.ID) {
              this.currentDifferentServieceList.push(temp);
            }
          }
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
// .container {
//   max-width: 590px;
// }
</style>
